import commercial from "../../images/commercial.png"
import React from 'react'

const ServiceCommercial = () => {
    return (
        <>
            <div className='container'>
                <h6 className='service-head '> ALL SERVICES</h6>
                <div className='row'>
                    <div className='col-lg-5'>
                        <img src={commercial} height={300} className='w-100 br-20' alt={commercial} />
                        <h3 className='color-primary  text-center mt-2'>Commercial Interior</h3>
                    </div>
                    <div className='col-lg-7 mt-5 mb-5'>
                        <h3>Innovative Commercial Interior Design That Inspires Success</h3>
                        <p>At AFS DOTE we believe that great design drives great business. Our expert team transforms commercial spaces into functional, visually stunning environments that enhance productivity, customer experience, and brand identity.
                        We specialize in designing for various industries, including:</p>
                        <ul>
                            <li>Corporate Offices – Modern, collaborative, and ergonomic workspaces.</li>
                            <li>Retail Stores – Engaging layouts that boost customer interaction and sales.</li>
                            <li>Hospitality Spaces – Welcoming interiors that create memorable guest experiences.</li>
                            <li>Healthcare Facilities – Comfortable, calming environments for patients and staff.</li>
                            <p>Our design philosophy focuses on blending aesthetics with practicality, ensuring your space not only looks exceptional but also functions seamlessly. From initial concept development to the final touches, we tailor every detail to reflect your brand’s values and meet your unique business needs.</p>
                            </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ServiceCommercial
